import HttpClient from '@chehejia/club-lib/lib/httpUtils/HttpClient';
import Constants from '../../enum/Constants';
import tool from '@util/tool';
import axios from 'axios';
import * as jose from 'jose';
import store from '../../model';


// 环境配置
const idaasConfig = {
      test: {
        // 前端应用
        client_id: '4jOebOvHeGaVRJ9mzxuqfb',
        multi_audience: {
            // 文章后台
            '3ZRsWJtiCgNF46jcCOj4Mp': {
                scope: 'PA openid login'
            },
            // 图片发布
            '1sBE38DZKVwwpRQ5FV27bM': {
                scope: 'read'
            }
        },
        article_audience: '3ZRsWJtiCgNF46jcCOj4Mp',
        img_audience: '1sBE38DZKVwwpRQ5FV27bM',
    },
    ontest: {
        // 前端应用
        client_id: '4jOebOvHeGaVRJ9mzxuqfb',
        multi_audience: {
            // 文章后台
            '3ZRsWJtiCgNF46jcCOj4Mp': {
                scope: 'PA openid login'
            },
            // 图片发布
            '1sBE38DZKVwwpRQ5FV27bM': {
                scope: 'read'
            }
        },
        article_audience: '3ZRsWJtiCgNF46jcCOj4Mp',
        img_audience: '1sBE38DZKVwwpRQ5FV27bM',
    },
    prod: {
      // 前端应用
      client_id: '4u4ctOfeAQBmzCMMpntV5g',
      multi_audience: {
          // 文章后台
          '37RbuyE1hxqmMiKNUdrpLR': {
              scope: 'PA openid'
          },
          // 图片发布
          'wcw0tHYDyS2CWwqEEIiBY': {
              scope: 'read'
          }
      },
      article_audience: '37RbuyE1hxqmMiKNUdrpLR',
      img_audience: 'wcw0tHYDyS2CWwqEEIiBY',
  }
};

const Env = window['serverEnv'] || 'ontest';

const clearAll = ()=>{
  localStorage.removeItem('img-id_token');
  localStorage.removeItem('img-access_token');
  localStorage.removeItem('img-refresh_token');

  localStorage.removeItem('artic-access_token');
  localStorage.removeItem('artic-id_token');
  localStorage.removeItem('artic-refresh_token');
  
  localStorage.removeItem('img-login_time')
  localStorage.removeItem('artic-login_time')
  localStorage.removeItem('img-expires_in');
  localStorage.removeItem('artic-expires_in');
  localStorage.removeItem('USERINFO');
  localStorage.removeItem('DEVICEID');
}

// 获取个人认证信息
const getAux = () => {
    const idaasAPI = Constants.getIdaas() + '/api/aux';
    // const formData = new FormData();
    // formData.append('client_id', '4jOebOvHeGaVRJ9mzxuqfb');
    // formData.append('scope', 'read');
    // formData.append('scope', 'read openid');
    // formData.append('scope', 'PA openid offline_access');
    // 云天读写 1sBE38DZKVwwpRQ5FV27bM  王宵数据 3ZRsWJtiCgNF46jcCOj4Mp
    // formData.append('audience', '3ZRsWJtiCgNF46jcCOj4Mp');
    return axios.post(
        idaasAPI,
        {
            client_id: idaasConfig[Env].client_id,
            multi_audience: idaasConfig[Env].multi_audience,
            offline_access: true
        },
        {
            headers: {
                // 'Content-Type': 'application/x-www-form-urlencoded'
                'Content-Type': 'application/json'
            }
        }
    );
};
export const refreshByToken = async (type: 'artic' | 'img') => {
    const params = new FormData();
    params.append('grant_type', 'refresh_token');
    if (type === 'artic') {
        params.append(
            'refresh_token',
            window.localStorage.getItem('artic-refresh_token')
        );
    } else {
        params.append(
            'refresh_token',
            window.localStorage.getItem('img-refresh_token')
        );
    }
    try {
        const idaasAPI = Constants.getIdaas() + '/api/token';
        const { data: res } = await axios.post(idaasAPI, params, {
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            }
        });
        if (type === 'artic') {
            window.localStorage.setItem('artic-id_token', res.id_token);
            window.localStorage.setItem('artic-access_token', res.access_token);
            // 刷新用
            window.localStorage.setItem(
                'artic-refresh_token',
                res.refresh_token
            );
            // 有效时长
            window.localStorage.setItem('artic-expires_in', res.expires_in);
        } else {
            res.id_token &&
                window.localStorage.setItem('img-id_token', res.id_token);
            window.localStorage.setItem('img-access_token', res.access_token);
            window.localStorage.setItem('img-refresh_token', res.refresh_token);
            window.localStorage.setItem('img-expires_in', res.expires_in);
        }
        return true;
    } catch (err) {
        console.error(err, '刷新失败');
        // todo 什么状态码就重新登录
        store.logout.init().then(() => {
          clearAll()
          window.location.href = '/login';
          
          store.hasLoginManage();
      });
        return false;
    }
};
//  轮查扫描状态
export const loopToken = data => {
    return new Promise(async (resolve, reject) => {
        const idaasAPI = Constants.getIdaas() + '/api/token';
        try {
            const { data: res } = await axios.post(idaasAPI, data, {
                headers: {
                    'Content-Type': 'application/json'
                }
            });
            const imgToken = res[idaasConfig[Env].img_audience] || {};
            // 文章权限
            const articlToken = res[idaasConfig[Env].article_audience] || {};
            if (imgToken) {
                // 共用文章的id_token
                window.localStorage.setItem(
                    'img-id_token',
                    articlToken.id_token
                );
                window.localStorage.setItem(
                    'img-access_token',
                    imgToken.access_token
                );
                // 刷新用
                window.localStorage.setItem(
                    'img-refresh_token',
                    imgToken.refresh_token
                );
                // 过期时间
                window.localStorage.setItem(
                    'img-expires_in',
                    imgToken.expires_in
                );
            }

            if (articlToken) {
                window.localStorage.setItem(
                    'artic-id_token',
                    articlToken.id_token
                );
                window.localStorage.setItem(
                    'artic-access_token',
                    articlToken.access_token
                );
                // 刷新用
                window.localStorage.setItem(
                    'artic-refresh_token',
                    articlToken.refresh_token
                );
                // 有效时长
                window.localStorage.setItem(
                    'artic-expires_in',
                    articlToken.expires_in
                );
            }
            // 登录时间
            window.localStorage.setItem('artic-login_time', Number(new Date()) + '');
            window.localStorage.setItem('img-login_time', Number(new Date()) + '');
            console.log(
                articlToken.id_token || imgToken.id_token,
                'articlToken.id_token || imgToken.id_token'
            );
            resolve(articlToken.id_token || imgToken.id_token);
        } catch (err) {
            reject(err);
        }
    });
};

export function unJwt(code) {
    //let test = `eyJhbGciOiJSUzI1NiIsImtpZCI6IjI2Q3V5ZCJ9.eyJzdWIiOiIxZXBORVZKNjBzSkVHSWdhWDdkSU9EIiwianRpIjoiNnhaS0ZoSGhvT043X01jV2FtYkxLdyIsImlzcyI6Imh0dHBzOi8vaWQtb250ZXN0LmxpeGlhbmcuY29tL2FwaS9kaXNjb3YvMUlQQjdKSzRnVzk0dGpRaGNGbWVaciIsImF1ZCI6IjFJUEI3Sks0Z1c5NHRqUWhjRm1lWnIiLCJleHAiOjE2MzMwNTUyMjcsImlhdCI6MTYzMjg4MjQyNywibmJmIjoxNjMyODgyNDI3LCJuaWNrbmFtZSI6IueQhuaDs-eUqOaItyIsInBpY3R1cmUiOiJodHRwczovL29pcy10ZXN0LXB1YmxpYy5hbXBtYWtlLmNvbS9haXNwL2FjY291bnQvaWFtL2F2YXRhcnMvR1pCMkFVWkZMSi5qcGcifQ.bN5-yb3HximMNE2zgjEDQZJ182iScuV99O3VhhUBXW06VDbtOcEbJqlmvOQP3ur-eMQMeci-cjMswne5qrlWhlo3IPD1l6Pu5bkL74jw1xa5f9nBtahomGSSLJ68XsxfpxZet6d3cgMIfn_8RGnatLBFmY4yhc-xQ2LR-eDPPnorVaEB4ob4ZR7-SJe4sqcyuR5GttEOv7bqNPdHVF9s209aHu0Ng1oidB8Wnm0Fw1ESwNrySEfsw_gpql8r572w-Z1WjK8VyT1LCLe1h7AW1GSoIYXjtVvQ_IXaMgUyiXn0E_kogul818AyvmrkPeXrxGNDvUzdgC5fTdNIjfYYWg`;
    const res = jose.decodeJwt(code);
    return res;
}
let auxInfo = { device_code: '' };
let jwtCode = '';
export default class LoginService {
    // 获取二维码
    public static getCode(param) {
        // todo 使用idaas提供方式获取 code
        return HttpClient.post(Constants.getLogin(), '/barcodes', param).then(
            data => {
                return data;
            }
        );
    }

    // 获取idaas二维码登录
    public static async getCodeIdaas() {
        const { data: getAuxRes } = await getAux();
        auxInfo = getAuxRes;
        window.localStorage.setItem('device_code', getAuxRes.device_code);
        window.localStorage.setItem('DEVICEID', getAuxRes.device_code);
        const urlObj = new URLSearchParams(
            new URL(getAuxRes.verification_uri_complete).search
        );
        const verification_uri_completeCode = urlObj.get('flow_id');
        console.log(verification_uri_completeCode);
        const scanCode = (22<<8) * 1 + Math.floor((Math.random()*255))
        const codeUrl = `https://www.lixiang.com/download?scanType=22&scanCode=${scanCode}&flow_id=${verification_uri_completeCode}`;
        return codeUrl;
    }

    // 在 idaas之后 轮训接口获取其他信息
    public static loopCodeState(callBack) {
        let numberTime = 0;
        const device_code = window.localStorage.getItem('device_code');
        let timeId = setInterval(async () => {
            numberTime++;
            try {
                const res = await loopToken({
                    grant_type: 'urn:ietf:params:oauth:grant-type:device_code',
                    device_code: device_code
                });
                //图片权限
                if (callBack && res) {
                    // 文章权限 // 解密
                    callBack(res);
                }

                if (res) {
                    setTimeout(async () => {
                        try {
                            const res2 = await loopToken({
                                grant_type: 'refresh_token',
                                refresh_token: window.localStorage.getItem(
                                    'artic-refresh_token'
                                )
                            });
                            console.log(res2, '------res2------');
                        } catch (e) {
                            console.log(e, '--------e------');
                        }
                    }, 2000);
                    clearInterval(timeId);
                }
            } catch (err) {
                console.log(err, '--err----');
                if (err.response.status !== 428) {
                    clearInterval(timeId);
                }
                console.error(err.response.status, '---errr');
            }
            console.log(numberTime);
            // 10分钟关掉
            if (numberTime > 10 * 60) {
                clearInterval(timeId);
            }
        }, 1000);
    }
    // 获取二维码状态
    public static getCodeStatus(
        securityStr: string,
        qrCode: string,
        businessId
    ) {
        return HttpClient.get(
            Constants.getLogin(),
            `/barcodes/${qrCode}/status?securityChain=${securityStr}&businessId=${businessId}`
        ).then(data => {
            return data;
        });
    }
    // 登录
    public static getLoginTokenService(loginParam) {
        return HttpClient.post(Constants.getLogin(), '/login', loginParam).then(
            data => {
                return data;
            }
        );
    }
    // 获取手机验证码
    /**
     *
     * @param param {
     * businessIdType*	integer($int32)
     *       allowEmptyValue: false
     *       业务类型，1：登陆，2：设置密码，3：设置安全码，4：三方绑定手机，5：修改手机号验证旧手机号，6：修改手机号验证新手机号
     *
     *      messageType*	integer($int32)
     *       allowEmptyValue: false
     *       消息类型，1：短信，2：语音
     *
     *       mobile*	string
     *       allowEmptyValue: false
     *       手机
     * }
     *
     */
    public static getPhoneCode(param) {
        const defaultParam = {
            messageType: 1
        };
        param = Object.assign(defaultParam, param);
        const config = {
            params: tool.urlSecurityCheck(param).queryObj
        };
        return HttpClient.post(
            Constants.getLogin(),
            '/sms-auth-codes',
            param,
            config
        ).then(data => {
            return data;
        });
    }
    /**
     * 校验手机验证码---登录
     * @param param{
     *      authCode	string
     *       allowEmptyValue: false
     *       授权码(code) 有值默认为授权登录
     *
     *       loginType	integer($int32)
     *       allowEmptyValue: false
     *       登录方式 1,APP 3,WEB
     *
     *       Enum:
     *       [ 1, 3 ]
     *       mobile*	string
     *       allowEmptyValue: false
     *       手机号
     *
     *       passwordCipher	string
     *       allowEmptyValue: false
     *       密码，密文传输
     *
     *       smsCode	string
     *       allowEmptyValue: false
     *       短信验证码code
     *
     *
     * }
     */
    public static verifyPhoneCodeLogin(param) {
        const defaultParam = {
            loginType: 3
        };
        param = Object.assign(defaultParam, param);
        return HttpClient.post(Constants.getLogin(), '/login', param).then(
            data => {
                return data;
            }
        );
    }
    // 判断用户是否登录，自动获取cookia
    // public static hasLogin() {
    //     return HttpClient.get(Constants.getLogin(), '/token-status').then(
    //         data => {
    //             return data;
    //         }
    //     );
    // }
    // idaas 判断用户是否登录
    public static hasLogin() {
        return new Promise((resolve, reject) => {
            // 通过 access_token 判断
            if (window.localStorage.getItem('artic-access_token')) {
                resolve(true);
            } else {
                reject(false);
            }
        });
    }
    public static loginIM() {
        return HttpClient.get(
            Constants.getLogin(),
            '/profile/tripartite/token?channel=1'
        ).then(data => {
            return data;
        });
    }

    // 退出登录
    public static logout() {
        // 原退出登录方法
        // return HttpClient.post(Constants.getLogin(), '/logout').then(data => {
        //     return data;
        // });
        // 退出登录
        const idaasAPI = Constants.getIdaas() + '/api/logout';
        const formData = new FormData();
        formData.append('client_id', `${idaasConfig[Env].client_id}`);
        formData.append('returnTo', `${window.location.href}`);
        const idToken = window.localStorage.getItem('artic-id_token');
        return axios.post(idaasAPI, formData, {
            headers: {
                Authorization: `Bearer ${idToken}`,
                'Content-Type': 'application/x-www-form-urlencoded'
            }
        });
    }

    // 系统权限判断
    public static isAuthority() {
        return HttpClient.get(Constants.getLogin(), '/profile/privileges').then(
            data => {
                return data;
            }
        );
    }
}
